import React from 'react';
import Config from '../../../Config';
import './ServiceEntryBlock.scss';

const resolveImageUrl = (imageRef) => {
  const rawPath = imageRef?.expandedValue?.url || imageRef?.value?.url || null;
  return rawPath ? Config.epiBaseUrl + rawPath : null;
};

const ServiceEntryCard = ({ card }) => {
  const text = card.cardText?.value;
  const iconUrl = card.icon?.expandedValue?.url
    ? Config.epiBaseUrl + card.icon.expandedValue.url
    : null;
  const linkUrl = card.link?.expandedValue?.url;

  const inner = (
    <div className="service-entry-card">
      {iconUrl && (
        <div className="service-entry-card__icon-wrap">
          <img className="service-entry-card__icon" src={iconUrl} alt="" />
        </div>
      )}
      {text && <p className="service-entry-card__text">{text}</p>}
    </div>
  );

  const slot = (child) => (
    <div
      className="service-entry-block__card-slot"
      style={{ animationDelay: '1s' }}
    >
      {child}
    </div>
  );

  if (linkUrl) {
    return slot(
      <a href={linkUrl} className="service-entry-card__link">
        {inner}
      </a>,
    );
  }

  return slot(<div>{inner}</div>);
};

const ServiceEntryBlock = ({ iContent }) => {
  const title = iContent.title?.value;
  const subtitleHtml = iContent.subtitle?.value;
  const backgroundImageDesktop = resolveImageUrl(iContent.backgroundImageDesktop);
  const backgroundImageMobile = resolveImageUrl(iContent.backgroundImageMobile);
  const cards = iContent.cards?.expandedValue;

  const heroStyle = {
    ...(backgroundImageDesktop
      ? { '--service-entry-bg-desktop': `url("${backgroundImageDesktop}")` }
      : {}),
    ...(backgroundImageMobile
      ? { '--service-entry-bg-mobile': `url("${backgroundImageMobile}")` }
      : {}),
  };

  return (
    <section className="service-entry-block">
      <div className="service-entry-block__hero" style={heroStyle}>
        <div className="service-entry-block__hero-overlay" aria-hidden="true" />
        <div className="service-entry-block__hero-inner">
          {title && <h1 className="service-entry-block__title">{title}</h1>}
          {subtitleHtml && (
            <div
              className="service-entry-block__subtitle"
              dangerouslySetInnerHTML={{ __html: subtitleHtml }}
            />
          )}
        </div>
      </div>

      <div className="service-entry-block__cards-outer">
        <div className="service-entry-block__cards">
          {cards?.map((card, index) => (
            <ServiceEntryCard key={index} card={card} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceEntryBlock;
